import {
  Directive,
  Input,
  Output,
  EventEmitter,
  ElementRef,
  OnInit,
  HostListener,
} from "@angular/core";
import {
  debounceTime,
  distinctUntilChanged,
  exhaustMap,
  filter,
  fromEvent,
  map,
  Observable,
  pairwise,
  startWith,
} from "rxjs";

interface ScrollPosition {
  sH: number;
  sT: number;
  cH: number;
}

const DEFAULT_SCROLL_POSITION: ScrollPosition = {
  sH: 0,
  sT: 0,
  cH: 0,
};

// InfiniteScrollContext represents the context in which the directive will run.
//
// The default is 'document' and this will trigger your action when the end of
// your element has been reached relative to the documents scrollbar.
//
// If you use 'self', your action will be triggered when the end of your element
// has been reached relative to your elements own scrollbar.
@Directive({
  selector: "[fpxInfiniteScroll]",
})
export class FpxInfiniteScrollDirective {
  private scrollEvent$: Observable<any> = new Observable<any>();


  @Output() scrollCallback: EventEmitter<any> = new EventEmitter();

  @Input()
  immediateCallback: boolean = true;

  @Input()
  scrollPercent: number = 75;
  percentValue: number;

  triggerScroll: boolean;

  constructor(private elm: ElementRef) {}

  ngAfterViewInit() {
    this.registerScrollEvent();
    this.streamScrollEvents();
  }

  private registerScrollEvent() {
    this.scrollEvent$ = fromEvent(this.elm.nativeElement, "scroll");
  }

  private streamScrollEvents() {
     this.scrollEvent$.pipe(
      map(
        (e: any): ScrollPosition => ({
          sH: e.target.scrollHeight,
          sT: e.target.scrollTop,
          cH: e.target.clientHeight,
        })
      ),
      pairwise(),
      filter(
        (positions: any) =>
          this.isUserScrollingDown(positions) &&
          this.isScrollExpectedPercent(positions[1])
      ),
      debounceTime(1000),
      distinctUntilChanged()
    ).subscribe({
      next: () => {
        this.scrollCallback.next(true);
      },
      error: () => {
        throw new Error("Scroll not implemented properly ");
      },
      complete: () => {},
    });;
  }

  private isUserScrollingDown = (positions: any) => {
    return positions[0].sT < positions[1].sT;
  };

  private isScrollExpectedPercent = (position: any) => {
    console.log(((position.sT + position.cH) / position.sH) * 100);

    // if(this.triggerScroll && ((position.sT + position.cH) / position.sH) * 100 > this.scrollPercent) return false;
    // if(((position.sT + position.cH) / position.sH) * 100 > this.scrollPercent) {
    //   this.triggerScroll = true;
    // }
    // else this.triggerScroll = false;
    let isScrollExpectedPercent = (position.sT + position.cH) / position.sH > (this.scrollPercent / 100);
    // this.triggerScroll = false;
    return isScrollExpectedPercent;
  };
}
